import React from "react";
import { Carousel } from "react-bootstrap";
import NavBar from "../nav-bar/Nav";
import './landing-page.scss';

export default function Landing() {
    const slides = [
        {
            id: 'slideOne',
            heading: 'Accelerate MSP Sales Workflows',
            caption: 'Leverage client cyber risk insights to drive service and product alignment. Identify similar organizations to expand list of prospects.'
        },
        {
            id: 'slideTwo',
            heading: 'Streamline MSP Account Management and Growth',
            caption: 'Create a framework for ongoing value delivery across managed account by incorporating internal and external cyber risk findings.'
        },
        {
            id: 'slideThree',
            heading: 'Facilitate Cyber Insurance Broker Sales Conversations',
            caption: 'Lead client conversations with and understanding of client exposure and coverage needs.'
        },
        {
            id: 'slideFour',
            heading: 'Underwrite Cyber Insurance with Confidence',
            caption: 'Utilize fast and accurate SignetScore based cyber assessments that go beyond simple scans.'
        }
    ]

    const services = [
        {
            id: 'serviceOne',
            icon: 'query_stats',
            title: 'SignetScore based Cyber Risk Assessments',
            description: 'Fast and scalable SignetScore based assessments allow organizations to rapidly gain an understanding of an organization cyber risk profile.  SignetScore is a highly predictive risk score that does not rely on inherently inaccurate IP address based scanning data.'
        },
        {
            id: 'serviceTwo',
            icon: 'assured_workload',
            title: 'Cyber Risk Exposure and Loss Scenarios',
            description: 'Customizable cyber insurance aligned risk scenarios allow an MSP and cyber insurance brokers to rapidly develop a high level view of an organiztions cyber risk exposure.  This forms the foundation for follow on discussion regarding MSP service offerings and cyber insurance coverage limits. ' 
        },
        {
            id: 'serviceThree',
            icon: 'bookmarks',
            title: 'Peer Discovery for Growth',
            description: 'Peer organization discovery allows MSP and cyber insurance brokers to quickly identify additional organization that look similar to a given profiled organization.  These peers can then be prioritized for follow on analysis and sales prospecting. Identified peers can be further screened on the basis of additonal criteria.'
        }
    ]

    return(
        <div>
          <div className="gradient landing-hero">
            <NavBar variant="dark" />
            <Carousel className="landing-hero__carousel">
              {slides.map(slide => (
                <Carousel.Item key={slide.id}>
                  <Carousel.Caption className="carousel-slide text-center px-5">
                    <h1>{slide.heading}</h1>
                    <p>{slide.caption}</p>
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
          
          <div className="container" style={{paddingTop: '40px'}}>
              <div className="row">
                  {services.map(service => (
                      <div key={service.id} className="col-lg-4">
                          <div className="tile">
                              <span className="material-icons">{service.icon}</span>
                              <h2 className="tile-title">{service.title}</h2>
                              <p className="tile-description">{service.description}</p>
                          </div>
                      </div>
                  ))}
              </div>
          </div>



          
          <div className="marketing bg-color-5">
              <div className="container">
                  <div className="row featurette">
                  <div className="col-md-8">
                      <h2 className="featurette-heading color-1">Full spectrum of cyber risk assessments in a single platform. <span className="color-4">Balance speed and depth of the assessment as needed. </span></h2>
                      <p className="lead" style={{color: 'white'}}> SignetScore provides the most accurate cyber risk assessment based on external visiblity, Platform integrations with M365/AWS/Azure/GCP allow deeper insights based on internal data.  Custom assessments allow MSPs and cyber inurance brokers to offer differentiated readiness assessments.</p>
                      
                  </div>
                  <div className="col-md-4" style={{textAlign: 'center'}}>
                      <span className="material-icons icon-xl color-1">troubleshoot</span>
                  </div>
                  </div>
              </div>
          </div>

          <div className="marketing bg-color-10">
              <div className="container">
                  <div className="row featurette">
                      <div className="col-md-8 order-md-2">
                          <h2 className="featurette-heading color-7"> Simple CRQ. <span className="text-muted"> Cyber risk quantification that starts with the enterprise</span></h2>
                          <p className="lead"> 
                          Cyber risk quantification does not have to be overly complicated in order to facilitate risk management decisions. Configurable risk scenarios allow a range of options to be explored.  
                          </p>
                      </div>
                      <div className="col-md-4 order-md-1" style={{textAlign: 'center'}}>
                          <span className="material-icons icon-xl color-6">assured_workload</span>
                      </div>
                  </div>
              </div>
          </div>

          <div className="marketing bg-color-8">
              <div className="container">
                  <div className="row featurette">
                      <div className="col-md-8">
                          <h2 className="featurette-heading color-7">Fast flow underwriting. <span className="text-muted"> Rapid risk scoring based on predictive data.</span></h2>
			  <p className="lead"> 
                          Build flexible underwriting decision gates on the basis of SignetScore threholds that trigger go/no-go/maybe follow on actions.  Enable annual portfolio grooming by identifying the highest risk policies.
                          </p>
                      </div>
                      <div className="col-md-4 order-md-1" style={{textAlign: 'center'}}>
                          <span className="material-icons icon-xl color-2">schema</span>
                      </div>
                  </div>
              </div>
          </div>



        </div>
    )
}
